import React from "react";
import "./login.scss";
import LOGO from "../../assets/Images/globizz-logo.png";
import {
  Form,
  Field,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import FormTextField from "../../components/formFields/FormTextField";
import {
  passwordValidator,
  requiredValidator,
} from "../../components/formFields/CommonValidator";
import FormPasswordField from "../../components/formFields/FormPasswordField";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { employeeLogin } from "./loginSlice";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import MouseFollower from "./MouseFollower";

const LoginNew = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const loading = useAppSelector((state) => state.login.loading);

  const handleSubmit = async (values: any) => {
    const data = {
      user_name: values.UserName,
      password: values.Password,
    };
    const response = await dispatch(employeeLogin(data));
    if (response?.meta?.requestStatus === "fulfilled") {
      navigate("/");
    }
  };
  return (
    <>
      <MouseFollower />
      <div className="login_section">
        <div className="login_center_area">
          <div className="logo_area">
            <img src={LOGO} alt="logo" />
          </div>
          <div className="login_card">
            <h1>Login</h1>
            <Form
              onSubmit={handleSubmit}
              initialValues={{
                UserName: "",
                Password: "",
                RememberMe: false,
              }}
              render={(formRenderProps: FormRenderProps) => (
                <FormElement>
                  <Field
                    name={"UserName"}
                    type={"text"}
                    component={FormTextField}
                    label={"Username"}
                    placeholder="Enter your username"
                    validator={requiredValidator}
                    astrike={true}
                  />
                  <Field
                    name={"Password"}
                    type={"password"}
                    component={FormPasswordField}
                    label={"Password"}
                    placeholder="Enter your password"
                    validator={passwordValidator}
                    astrike={true}
                  />

                  <ButtonWithLoading
                    label="Login"
                    themeColor="primary"
                    type="submit"
                    width="100%"
                    className="loginbtn"
                    disabled={!formRenderProps.allowSubmit || loading}
                    loading={loading}
                  />
                </FormElement>
              )}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginNew;
